import type { AnyAction } from 'redux';
import {
  takeEvery,
  select,
  call,
  fork,
  SagaReturnType,
} from 'redux-saga/effects';
import { UPDATE_NAVBAR_CALLBACK } from '@corefront/redux-aba';
import { getGrowthBook } from '../../../services/growthbook';
import logger from '../../logger';
import {
  containerSelector,
  isDesktopSelector,
  isNativeSelector,
} from '../../reducers/app/params';
import FEATURES, { DEFAULT_VALUES } from '../../../constants/featureToggling';
import { CUSTOM_EVENT_IDS } from '../../../constants/customEvents';

export function* navbarWatcher() {
  yield takeEvery(UPDATE_NAVBAR_CALLBACK, navbarWorker);
}

export function* navbarWorker(action: AnyAction = { type: '' }) {
  const payload = action?.payload ?? {};
  const container: ReturnType<typeof containerSelector> = yield select(
    containerSelector
  );

  const item = payload?.item ?? '';
  const rest = payload?.data ?? {};

  const clickEvent = new CustomEvent(CUSTOM_EVENT_IDS.CasinoNavbarCLick, {
    detail: {
      item,
      ...rest,
    },
    bubbles: true,
  });
  try {
    const DOM_NODE = document.querySelector(container);
    DOM_NODE?.dispatchEvent?.(clickEvent);
  } catch (e) {
    logger.error(e);
  }
}

export function* externalNavbarEnabledChecker() {
  const isExternalNavbarEnabled = getGrowthBook()?.getFeatureValue(
    FEATURES.COMMON_NAVBAR,
    DEFAULT_VALUES.COMMON_NAVBAR
  );
  const isNative: ReturnType<typeof isNativeSelector> = yield select(
    isNativeSelector
  );
  const isDesktop: ReturnType<typeof isDesktopSelector> = yield select(
    isDesktopSelector
  );

  return isExternalNavbarEnabled && !isNative && !isDesktop;
}

export function* commonNavbar() {
  const isExternalNavbarEnabled: SagaReturnType<
    typeof externalNavbarEnabledChecker
  > = yield call(externalNavbarEnabledChecker);

  if (isExternalNavbarEnabled) {
    yield fork(navbarWatcher);
  }
}
